import React from "react"
import { connect } from "react-redux"
import { push as pushAction } from "connected-react-router"

import "./BasicCard.less"

function cutName(s) {
  if (s.indexOf("(") > 0) {
    return s.split("(")[0]
  }
  else if (s.indexOf("（") > 0) {
    return s.split("（")[0]
  }
  else {
    return s
  }
}

const BasicCard = ({ product, onClick }) => {
  const notHasSpanish = new RegExp(`^[^A-z]+$`, "g").test(product.chName)

  return (
    <div className="basic-card-page" onClick={onClick}>
      <div className="envoltorio">

        <div 
          className="image" 
          style={{ backgroundImage: "url(" + product.foreground.image + ")" }}
        >
          &nbsp;
        </div>
        
        <div className="text">
          <div>{cutName(product.chName)}</div>
          {notHasSpanish && (
            <div className="i">
              {product.name}
            </div>
          )}
        </div>

      </div>
    </div>
  )

}

const mapStateToProps = (_state, _ownProps) => ({})

const mapDispatchToProps = dispatch => ({
  push: (url) => dispatch(pushAction(url)),
})

export default connect(mapStateToProps, mapDispatchToProps)(BasicCard)


// WEBPACK FOOTER //
// ./src/app/catalogo/components/BasicCard.jsx